import React from 'react'
import Badge from '@mui/material/Badge'
import { styled } from '@mui/system'
import { SxProps, Theme } from '@mui/material/styles'
import { TUserStatus } from 'src/services/auth/users'
import { getStatusColor } from './statusColor'

const StatusDot = styled('span')<{ status?: TUserStatus | null; size: number }>(
  ({ theme, status, size }) => ({
    width: size,
    height: size,
    borderRadius: '50%',
    backgroundColor: getStatusColor(theme as Theme, status),
    boxShadow: `0 0 0 2px ${(theme as Theme).palette.background.paper}`,
  })
)

interface IProps {
  status?: TUserStatus | null
  size?: number
  sx?: SxProps<Theme>
  children: React.ReactNode
}

/** An avatar (or anything round) with the presence dot in its bottom right corner */
const UserStatusBadge = ({ status, size = 8, sx, children }: IProps) => (
  <Badge
    overlap="circular"
    sx={sx}
    badgeContent={<StatusDot status={status} size={size} />}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
  >
    {children}
  </Badge>
)

export default UserStatusBadge
